import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';

interface StepperProgressBarProps {
  stepsNumber: number;
  currentStep?: number;
  horizontal?: boolean;
  size: number;
}

export function StepperProgressBar({
  size,
  stepsNumber,
  currentStep,
  horizontal,
}: StepperProgressBarProps) {
  return (
    <>
      <ProgressBar
        size={size}
        stepsNumber={stepsNumber}
        horizontal={horizontal}
      />
      <ProgressBar
        size={size}
        stepsNumber={stepsNumber}
        currentStep={currentStep}
        horizontal={horizontal}
      />
    </>
  );
}

const progressBarMargin = ({
  currentStep,
  stepsNumber,
  horizontal,
  size,
}: StepperProgressBarProps) => {
  if (!currentStep) {
    return horizontal ? size * (stepsNumber - 1) : size * stepsNumber;
  }

  return currentStep < stepsNumber
    ? size * (currentStep - 1)
    : size * (stepsNumber - 1);
};

const ProgressBar = styled.View<StepperProgressBarProps>`
  height: ${({ horizontal, currentStep, stepsNumber, size }) =>
    horizontal
      ? 4
      : progressBarMargin({ currentStep, stepsNumber, size, horizontal })}px;
  width: ${({ horizontal, currentStep, stepsNumber, size }) =>
    horizontal
      ? progressBarMargin({ currentStep, stepsNumber, size, horizontal })
      : 4}px;
  position: absolute;
  ${({ currentStep, horizontal, size }) =>
    !horizontal && `top: ${currentStep ? size - 8 : 0}px`};
  ${({ horizontal }) => horizontal && `left: 8px`};
  background-color: ${({ currentStep, theme: { color } }) =>
    currentStep ? color.accent : color.light1};
`;
